var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"component-paginate-tablecell"},[_c('div',{staticClass:"paginate-tablecell-container"},[_c('div',{staticClass:"paginate-tablecell-data"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }